import React from "react";

import _str from "shared/util/_str";
import Actions from "okpay/actions/Actions";
import TextInput from "okpay/util/TextInput";
import classnames from "classnames";

class ZipCode extends React.Component {
	_onChange = (e) => {
		const { value } = e.target;
		return Actions.updateField({ zipCode: value });
	};

	render() {
		let label;
		const classes = classnames({
			"okpay-item": true,
			"okpay-item-zipcode": true,
		});

		if (this.props.isUS) {
			label = "Zip Code";
		} else {
			label = "Postal Code";
		}

		return (
			<div className={classes}>
				<div className="okpay-item-element">
					<TextInput
						value={this.props.value}
						name="zipCode"
						label={_str(label)}
						autoComplete="on"
						onChange={this._onChange}
						maxLength={10}
					/>
				</div>
			</div>
		);
	}
}

export default ZipCode;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/fields/ZipCode.jsx